export default "__VITE_ASSET__CF_29wnK__"